import React, { useContext, useEffect } from "react";
import { ResultsMenuStoreContext } from "@state/context/results";
import { useNotification } from "@utils/notifications";
import ResultsSportList from "./ResultsSportList";

export default function ResultsSports() {
	const { showError } = useNotification();

	const store = useContext(ResultsMenuStoreContext);

	useEffect(() => {
		async function fetchData() {
			try {
				await store.onInitialize();
			} catch (error) {
				showError(error);
			}
		}

		fetchData();
	}, []);

	return <ResultsSportList />;
}
